import { __rest } from "tslib";
import React, { forwardRef, useRef, useEffect } from 'react';
import { createReactWrapper } from '../common/PrefixUtils';
import { addExtraProps } from '../common/utils/AddExtraProps';
import { handleForwardRef } from '../common/RefUtils';
import { ChangeSyntheticEvent } from '../common/SyntheticEvent';
export function generateInputFieldBase(tagName, _a, ref) {
    var { children, leadingIcon, trailingIcon, value = '', form, onKeyUp, onKeyDown, onChange, autoFocus, helperText } = _a, otherProps = __rest(_a, ["children", "leadingIcon", "trailingIcon", "value", "form", "onKeyUp", "onKeyDown", "onChange", "autoFocus", "helperText"]);
    const inputFieldRef = useRef();
    const handledRef = handleForwardRef(inputFieldRef, ref);
    const handleKeyUp = (event) => {
        if (onChange) {
            const changeEvent = event;
            const currentValue = changeEvent.target.value;
            const ignoreList = ['Enter', 'Escape', 'Tab'];
            const deleteKeys = ['Backspace', 'Delete'];
            const isValueEqual = value === currentValue;
            const isEmptyDelete = isValueEqual && deleteKeys.find((key) => changeEvent.key === key);
            if (ignoreList.find((key) => changeEvent.key === key) ||
                changeEvent.ctrlKey ||
                changeEvent.altKey ||
                isEmptyDelete ||
                isValueEqual) {
                return;
            }
            inputFieldRef.current.$emit('change');
        }
        if (onKeyUp) {
            onKeyUp(event);
        }
    };
    const handleChange = (event) => {
        if (onChange) {
            onChange(new ChangeSyntheticEvent(event));
        }
    };
    const handleKeyDown = (event) => {
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    useEffect(() => {
        var _a, _b, _c;
        (_a = inputFieldRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keyup', handleKeyUp);
        (_b = inputFieldRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('keydown', handleKeyDown);
        (_c = inputFieldRef.current) === null || _c === void 0 ? void 0 : _c.addEventListener('change', handleChange);
        return () => {
            var _a, _b, _c;
            (_a = inputFieldRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keyup', handleKeyUp);
            (_b = inputFieldRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('keydown', handleKeyDown);
            (_c = inputFieldRef.current) === null || _c === void 0 ? void 0 : _c.removeEventListener('change', handleChange);
        };
    }, [ref, onChange, onKeyUp, onKeyDown]);
    useEffect(() => {
        if (inputFieldRef && inputFieldRef.current) {
            inputFieldRef.current.value = value;
        }
    }, [ref, value]);
    return createReactWrapper({
        tagName,
        props: Object.assign(Object.assign({}, otherProps), { form: form === null || form === void 0 ? void 0 : form.id, autofocus: autoFocus, ref: handledRef }),
        children: (React.createElement(React.Fragment, null,
            leadingIcon && addExtraProps(leadingIcon, { slot: 'start' }),
            children,
            trailingIcon && addExtraProps(trailingIcon, { slot: 'end' }),
            helperText && addExtraProps(helperText, { slot: 'helpertext' }))),
    });
}
export const TextField = forwardRef((props, ref) => generateInputFieldBase('chameleon-text-field', props, ref));
